import { Dispatch, Middleware, MiddlewareAPI } from "redux";
import { API_REQUEST } from "../actionTypes/actionsTypes";
import { AppAction, AsyncActionType } from "../types";
import { LOGIN_AUTH } from "../actionTypes/actionsTypes"
import { setToken } from "../actions/auth/token";

export const server = process.env.REACT_APP_AMP_API || "http://localhost:4000";

const apiMiddleware: Middleware = (api: MiddlewareAPI) => (next: Dispatch) => (action: AppAction): AppAction => {
  const handleResponse = (response: Record<string, unknown>) => {
    const { ...rest } = action.payload;
    
    if (response.message && response.message === "Token Expired") {
      window.localStorage.clear();

      api.dispatch(setToken(false));

      api.dispatch({
          type: LOGIN_AUTH.SUCCESS,
          payload: { token: null, user_profile_id: null, success: false }
      })
    }

    api.dispatch({
      type: (action.payload.next as AsyncActionType).SUCCESS,
      payload: { ...rest, ...response, "status": response.status },
    });
  };

  if (action.type === API_REQUEST) {

    const doAuth = action.payload.authorization;
    let authHeader = {};
    if (doAuth) {
      // Registration token not stored in local storage
      if(typeof(doAuth) == "string"){
        authHeader = {
          "Authorization": doAuth
        }
      // Normal Authentication Token
      } else {
        authHeader = {
          "Authorization": window.localStorage.getItem("amptoken")
        }
      }
    }

    const requestParams: RequestInit  = {
        method: action.payload.method, // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            ...authHeader
        },
        body: JSON.stringify(action.payload.data),
        redirect: 'follow', // manual, *follow, error
    }

    fetch(`${server}${action.payload.url}`, requestParams)
    .then(response => {
      return new Promise<Record<string, unknown>>((resolve, reject) => {
        response.json().then((responseObj: Record<string, unknown>) => {
          resolve(({...responseObj, "status": response.status} as Record<string, unknown>))
        }).catch(error => reject(error))
      })
    })
    .then(handleResponse)
    .catch(error => {
        const errorRes = {
          status: error.status,
          body: error
        }
        api.dispatch({ type: (action.payload.next as AsyncActionType).ERROR, errorRes });
    });
    api.dispatch({ type: (action.payload.next as AsyncActionType).PENDING });
  }
  if(process.env.NODE_ENV !== 'production'){
    console.log(action)
  }
  return next(action);
};

export default apiMiddleware; 
